var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6376 5.27326C13.692 5.27326 14.5467 4.41853 14.5467 3.36417C14.5467 2.30981 13.692 1.45508 12.6376 1.45508C11.5832 1.45508 10.7285 2.30981 10.7285 3.36417C10.7285 4.41853 11.5832 5.27326 12.6376 5.27326Z",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00089 9.90998C4.05525 9.90998 4.90998 9.05525 4.90998 8.00089C4.90998 6.94653 4.05525 6.0918 3.00089 6.0918C1.94653 6.0918 1.0918 6.94653 1.0918 8.00089C1.0918 9.05525 1.94653 9.90998 3.00089 9.90998Z",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5467 4L4.72852 7.2",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6376 14.5467C13.692 14.5467 14.5467 13.692 14.5467 12.6376C14.5467 11.5832 13.692 10.7285 12.6376 10.7285C11.5832 10.7285 10.7285 11.5832 10.7285 12.6376C10.7285 13.692 11.5832 14.5467 12.6376 14.5467Z",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5467 12.0008L4.72852 8.80078",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedIcon);
export default __webpack_public_path__ + "static/media/shared-icon.ee7f0cb49e539a78657130982065f433.svg";
export { ForwardRef as ReactComponent };